/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  emailToSms: [],
}

export const GetListOfEmailtoSms: any = createAsyncThunk(
  'GetListOfEmailtoSms',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}emailmessage`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const globalsettingUpdate: any = createAsyncThunk(
  'globalsettingUpdate',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}user/profileconfig`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(GetListOfEmailtoSms())
    thunkApi.dispatch(fetchAsyncUserDetails())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const createEmailToSms: any = createAsyncThunk(
  'createEmailToSms',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}emailmessage`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(GetListOfEmailtoSms())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const updateEmailToSms: any = createAsyncThunk(
  'updateEmailToSms',
  async (data: any, thunkApi) => {
    const response = await axios.put(`${API_URL}emailmessage/${data?.id}`, data?.finalData, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(GetListOfEmailtoSms())
    thunkApi.dispatch(stopLoading())
    response?.data?.status == true && toast.success(response.data.message)
    return response.data
  }
)
export const deleteEmailToSms: any = createAsyncThunk(
  'deleteEmailToSms',
  async (data: any, thunkApi) => {
    const response = await axios.delete(`${API_URL}emailmessage/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(GetListOfEmailtoSms())
    thunkApi.dispatch(stopLoading())

    response?.data?.status == true && toast.success(response.data.message)
    return response.data
  }
)

const emailToSMS = createSlice({
  name: 'emailToSMS',
  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(GetListOfEmailtoSms.fulfilled, (state, action) => {
      return {...state, emailToSms: action?.payload}
    })
  },
})

export const getEmailToSms = (state: any) => state?.emailToSMS?.emailToSms?.data
export default emailToSMS.reducer
